module.exports = __webpack_public_path__ + "static/media/P200-thumb-wheel.dd1f58a0.svg";